import React, { useState } from 'react';
import { Modal, Button } from '@storable/canaveral-components';
import gql from 'graphql-tag';
import TextareaInput from '../../../../modules/react/components/stateful/TextareaInput';
import styles from './AddEmailModal.scss';
import useMutation from '../../../../modules/react/hooks/useMutation';

const SEND_EVENT_DATA_LAKE = gql`
mutation SaveReciepientEmail ($emails: [String!]!, $pageId: String!) {
  updatePageEmail(emails: $emails, pageId: $pageId) {
    userErrors {
      message
    }
  }
}
`;

const AddEmailModal = (props) => {
  const { onDismiss, onSubmit, show, pageId, emails = [] } = props;
  const [value, setValue] = useState(emails.join(','));
  const [showError, setShowError] = useState(false);
  const [sendEvent] = useMutation(SEND_EVENT_DATA_LAKE);


  const onEmailChange = (newVal) => {
    setValue(newVal);
    setShowError(false);
  };

  const onModalSubmit = () => {
    const emailList = value.replace(/^\s+|\s+$|\s+(?=\s)/g, '').split(',');
    const invalidEmails = emailList.filter(email => !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email));

    if (invalidEmails.length) {
      setShowError(true);
      return;
    }
    sendEvent({ variables: { emails: emailList, pageId } });

    setShowError(false);
    onSubmit(emailList);
  };

  return (
    <Modal
      show={show}
      onDismiss={onDismiss}
      aria-labelledby="admin-add-email"
    >
      <Modal.Header>
        <Modal.Title id="admin-add-email">Add Email Ids</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          <strong>
            Add the Email Ids you want to receive details on.
          </strong>
        </p>
        <TextareaInput
          value={value}
          autoBlur
          clearable={false}
          placeholder="Enter valid Email-Id/Email-Ids separated by comma"
          className={styles.TextareaInput}
          onChange={(e) => {
            onEmailChange(e.target.value);
          }
          }
        />
        {showError && (
          <p className={styles.error}>
            Please enter valid email ids.
          </p>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button
          size="sm"
          context="neutral"
          onClick={onDismiss}
        >
          Close
        </Button>
        <Button
          size="sm"
          context="positive"
          onClick={onModalSubmit}
        >
          Add Email
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AddEmailModal;
